namespace GeniuzPOS.SalePromoCamp {
    export interface PromoDayRow {
        Id?: number;
        PromoDay?: number;
        PromoDayName?: string;
    }

    export namespace PromoDayRow {
        export const idProperty = 'PromoDay';
        export const nameProperty = 'PromoDayName';
        export const localTextPrefix = 'SalePromoCamp.PromoDay';
        export const lookupKey = 'SalePromoCamp.PromoDay';

        export function getLookup(): Q.Lookup<PromoDayRow> {
            return Q.getLookup<PromoDayRow>('SalePromoCamp.PromoDay');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PromoDay = "PromoDay",
            PromoDayName = "PromoDayName"
        }
    }
}
